import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGlobe,
  faCheck,
  faRocket,
  faLock,
  faChartLine,
  faDollarSign,
  faBullseye,
  faClipboard,
  faClock,
  faShield,
  faBolt,
  faTasks,
  faHeadset,
  faGraduationCap,
  faStar,
  faAward,
  faShake,
  faBriefcase,
  faChartBar,
  faHandshake,
  faSearch,
  faUsers,
  faLaptop,
  faWallet,
  faPlane,
} from "@fortawesome/free-solid-svg-icons";
import NavBar from "../Navigation/NavBar";
import Footer from "../Footer/Footer";
import Services1 from "./IMG/Services1.png";
import Services2 from "./IMG/Services2.png";
import Services3 from "./IMG/Services3.png";
import Services4 from "./IMG/Services4.png";
import Services5 from "./IMG/Services5.png";
import Services6 from "./IMG/Services6.png";
import Services7 from "./IMG/Services7.png";
import Services8 from "./IMG/Services8.png";

import WorldMap from "./IMG/WorldMap.svg";
import "./Services.css";

function MainServices() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const services = [
    {
      id: "permanent-staffing",
      title: "Permanent Staffing Solutions",
      image: Services1,
      icon: faStar,
      shortDesc: "Global recruitment connecting talent with opportunity",
    },
    // {
    //   id: "temporary-staffing",
    //   title: "Temporary Staffing",
    //   image: Services2,
    //   icon: faBolt,
    //   shortDesc: "Flexible staffing solutions for your business needs",
    // },
    // {
    //   id: "payroll-management",
    //   title: "Payroll Management",
    //   image: Services3,
    //   icon: faWallet,
    //   shortDesc: "Accurate, timely compensation management",
    // },
    {
      id: "dedicated-it",
      title: "Dedicated IT Resources",
      image: Services4,
      icon: faLaptop,
      shortDesc: "Expert IT professionals for your projects",
    },
    {
      id: "international-recruitment",
      title: "International Recruitment",
      image: Services5,
      icon: faGlobe,
      shortDesc: "Comprehensive global hiring solutions",
    },
    {
      id: "executive-search",
      title: "Executive Recruitment",
      image: Services6,
      icon: faBriefcase,
      shortDesc: "Top-tier leadership talent acquisition",
    },
    {
      id: "bulk-hiring",
      title: "Bulk Hiring Services",
      image: Services7,
      icon: faUsers,
      shortDesc: "Large-scale recruitment with precision",
    },
    {
      id: "visa-assistance",
      title: "Visa Assistance",
      image: Services8,
      icon: faPlane,
      shortDesc: "Fast and reliable visa processing",
    },
  ];

  const handleServiceClick = (serviceId) => {
    navigate(`/service-details/${serviceId}`);
  };

  return (
    <>
      <Helmet>
        <title>Expert Staffing Solutions for Your Business Needs | Quarec Resources</title>
        <meta
          name="description"
          content="Quarec Resources Pvt. Ltd. offers expert HR consultancy, comprehensive staffing solutions, and innovative IT services to help your business thrive."
        />
        <meta name="keywords" content="HR solutions, placement services, recruitment, Quarec Resources" />
        <meta name="author" content="Quarec Resources" />
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <div className="Services-Hero">
        {/* <div className="Services-Hero-Content">
          <h1 className="Services-Hero-Title">Our Services</h1>
          <p className="Services-Hero-Subtitle">
            Comprehensive staffing solutions designed to connect talent with opportunity globally
          </p>
        </div> */}
      </div>

      {/* Services Gallery Section */}
      <div className="gallery-wrapper">
        <div className="gallery-container">
          <h2 className="gallery-section-title">Our Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="service-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-card-image-wrapper">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-card-image"
                  />
                  <div className="service-card-overlay"></div>
                  <div className="service-card-badge">
                    <FontAwesomeIcon icon={service.icon} />
                  </div>
                </div>

                <div className="service-card-content">
                  <h3 className="service-card-title">{service.title}</h3>
                  <p className="service-card-desc">{service.shortDesc}</p>
                  <div className="service-card-footer">
                    <a
                      className="service-card-btn"
                      href={`/service-details/${service.id}`}
                    >
                      View Details
                      <span className="arrow">→</span>
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Permanent Staffing Solutions */}
      {/* <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">⭐ GLOBAL RECRUITMENT</div>
            <h2 className="Service-Title">Permanent Staffing Solutions</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources is a premier recruitment firm dedicated to connecting talent from around the world with exciting opportunities across national and international job markets. Our extensive reach and expertise allow us to connect skilled professionals with the best job opportunities in regions such as the Middle East, Africa, Canada, UK, Australia, and beyond.
              </p>
              <p className="Service-Paragraph">
                With a focus on professional recruiting principles, we ensure a seamless and effective recruitment process that maximizes the potential of our diverse clientele. Our mission is to help individuals build a safe and secure future by connecting them with international job prospects that offer growth and stability.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faGlobe} /></div>
                <div className="Feature-Text">Global Reach</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faCheck} /></div>
                <div className="Feature-Text">Best Matches</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faRocket} /></div>
                <div className="Feature-Text">Career Growth</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faLock} /></div>
                <div className="Feature-Text">Secure Future</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={WorldMap} alt="Global Staffing Network" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Temporary Staffing */}
      {/* <div className="Service-Section">
        <div className="Service-Container reverse">
          <div className="Service-Content">
            <div className="Service-Badge">⚡ FLEXIBLE STAFFING</div>
            <h2 className="Service-Title">Temporary Staffing</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources is a staffing agency that offers temporary staffing solutions. We excel at sourcing and vetting candidates for different positions, taking care of administrative tasks such as contracts and payroll. Our temporary workers seamlessly integrate into client teams and contribute to their overall success.
              </p>
              <p className="Service-Paragraph">
                We provide clients with scalability, cost-effectiveness, access to specialized skills, and the chance to evaluate potential permanent hires. Temporary workers benefit from valuable experience, exposure to diverse industries, networking opportunities, and potential pathways to permanent employment.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faChartLine} /></div>
                <div className="Feature-Text">Scalability</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faDollarSign} /></div>
                <div className="Feature-Text">Cost-Effective</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faBullseye} /></div>
                <div className="Feature-Text">Specialized Skills</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faClipboard} /></div>
                <div className="Feature-Text">Full Compliance</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-2"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services2} alt="Temporary Staffing" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Payroll Management */}
      {/* <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">💳 PAYROLL & HR</div>
            <h2 className="Service-Title">Payroll Management</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                At Quarec Resources, our payroll management ensures accurate and timely compensation for our temporary workers. Our dedicated team handles timekeeping, wage calculation, deductions, and payroll processing with meticulous attention to detail.
              </p>
              <p className="Service-Paragraph">
                We comply with legal requirements, providing detailed payslips and maintaining confidentiality. With efficient processes in place, we prioritize accuracy and transparency. Our goal is to ensure that our temporary workers receive their wages on time and are supported throughout the payroll process.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faClock} /></div>
                <div className="Feature-Text">Timely Processing</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faCheck} /></div>
                <div className="Feature-Text">Accuracy Guaranteed</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faShield} /></div>
                <div className="Feature-Text">Legal Compliance</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faLock} /></div>
                <div className="Feature-Text">Data Security</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services3} alt="Payroll Management" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Dedicated IT Resources */}
      {/* <div className="Service-Section">
        <div className="Service-Container reverse">
          <div className="Service-Content">
            <div className="Service-Badge">💻 IT SOLUTIONS</div>
            <h2 className="Service-Title">Dedicated IT Resources</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Quarec Resources offers dedicated IT resources and teams to support a wide range of projects. Our skilled IT professionals are available to provide specialized expertise and assistance tailored to your specific needs. Whether you require support for software development, system administration, network infrastructure, or cybersecurity.
              </p>
              <p className="Service-Paragraph">
                Our dedicated resources are ready to contribute their knowledge and skills. We ensure that our IT teams are equipped with the latest technologies and tools to deliver efficient and effective solutions. Partner with Quarec Resources to access dedicated IT resources that will drive the success of your projects.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faTasks} /></div>
                <div className="Feature-Text">Technical Expertise</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faHeadset} /></div>
                <div className="Feature-Text">24/7 Support</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faBolt} /></div>
                <div className="Feature-Text">Latest Technology</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faGraduationCap} /></div>
                <div className="Feature-Text">Expert Team</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-2"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services4} alt="Dedicated IT Resources" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* International Recruitment */}
      {/* <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">🌐 INTERNATIONAL HIRING</div>
            <h2 className="Service-Title">International Recruitment</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                At Quarec Resources, we specialize in international recruitment, assisting companies in sourcing and hiring talented professionals from around the world. We understand the complexities of global hiring and provide comprehensive solutions including visa support, cultural orientation, and relocation logistics.
              </p>
              <p className="Service-Paragraph">
                Our process includes candidate screening, skill assessment, travel arrangements, and on boarding support. We ensure a smooth transition for international hires while maintaining full compliance with immigration laws. Let us handle the complexities of international recruitment while you focus on growing your business.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faClipboard} /></div>
                <div className="Feature-Text">Visa Support</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faGlobe} /></div>
                <div className="Feature-Text">Travel Logistics</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faBullseye} /></div>
                <div className="Feature-Text">Skill Screening</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faHandshake} /></div>
                <div className="Feature-Text">Cultural Support</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services5} alt="International Recruitment" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Executive Search */}
      {/* <div className="Service-Section">
        <div className="Service-Container reverse">
          <div className="Service-Content">
            <div className="Service-Badge">👔 EXECUTIVE SEARCH</div>
            <h2 className="Service-Title">Executive Recruitment</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                Our executive search and recruitment services identify top-tier leadership talent for your organization. We understand that finding the right executive is critical for organizational success and utilize our extensive network of industry leaders and professionals.
              </p>
              <p className="Service-Paragraph">
                We conduct thorough vetting processes including background checks, skills assessments, and cultural fit analysis. Our consultants work closely with your leadership team to ensure that candidates align with your strategic vision. We provide personalized support throughout the entire journey from assessment to negotiation and onboarding.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faStar} /></div>
                <div className="Feature-Text">Top Talent Only</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faSearch} /></div>
                <div className="Feature-Text">Deep Vetting</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faHandshake} /></div>
                <div className="Feature-Text">Cultural Fit</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faBullseye} /></div>
                <div className="Feature-Text">Direct Contact</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-2"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services6} alt="Executive Search" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      {/* Bulk Hiring */}
      {/* <div className="Service-Section">
        <div className="Service-Container">
          <div className="Service-Content">
            <div className="Service-Badge">👥 MASS RECRUITMENT</div>
            <h2 className="Service-Title">Bulk Hiring Services</h2>
            <div className="Service-Description">
              <p className="Service-Paragraph">
                For organizations looking to expand their workforce rapidly, our bulk hiring services provide comprehensive recruitment solutions. We handle large-scale recruitment projects with efficiency, managing everything from candidate sourcing to onboarding with precision and speed.
              </p>
              <p className="Service-Paragraph">
                Our team understands the complexities of hiring in volume while maintaining quality standards. We leverage our extensive network and advanced screening processes to deliver qualified candidates that meet your specific requirements and company culture, all within your timeline.
              </p>
            </div>
            <div className="Service-Features">
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faTasks} /></div>
                <div className="Feature-Text">Streamlined Process</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faClock} /></div>
                <div className="Feature-Text">Quick Turnaround</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faBullseye} /></div>
                <div className="Feature-Text">Quality Assurance</div>
              </div>
              <div className="Feature-Item">
                <div className="Feature-Icon"><FontAwesomeIcon icon={faChartBar} /></div>
                <div className="Feature-Text">Real-time Analytics</div>
              </div>
            </div>
          </div>
          <div className="Service-Image-Wrapper">
            <div className="Decorative-Shape Decorative-Shape-1"></div>
            <div className="Service-Image-Container">
              <img className="Service-Image" src={Services7} alt="Bulk Hiring" />
              <div className="Image-Overlay"></div>
            </div>
          </div>
        </div>
      </div> */}

      <Footer />
    </>
  );
}

export default MainServices;
